import React, { useState, useEffect, useRef, useContext, Fragment } from "react";

import * as Yup from "yup";
import { Formik, FieldArray, Form, Field } from "formik";
import { toast } from "react-toastify";

import clsx from "clsx";
import { FormControl, FormControlLabel, InputLabel, MenuItem, Select, Tab, Tabs } from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import SaveIcon from "@material-ui/icons/Save";
import EditIcon from "@material-ui/icons/Edit";
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";
import { i18n } from "../../translate/i18n";
import Switch from "@material-ui/core/Switch";
import { isArray } from "lodash";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import ColorPicker from "../ColorPicker";
import { IconButton, InputAdornment } from "@material-ui/core";
import { Colorize } from "@material-ui/icons";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import ConfirmationModal from "../ConfirmationModal";
import Checkbox from '@mui/material/Checkbox';

import OptionsChatBot from "../ChatBots/options";
import { useBotTreeStyles, BotTree, BotNode, BotTitle, BotIconButton, BotAdd } from "../ChatBots/tree";
import { usePanelStyles, ModalTitle, FormSection, SettingRow } from "../FormFields/panel";
import { getTokens } from "../../styles/tokens";
import CustomToolTip from "../ToolTips";

import SchedulesForm from "../SchedulesForm";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import { AuthContext } from "../../context/Auth/AuthContext";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";
import useQueues from "../../hooks/useQueues";
import UserStatusIcon from "../UserModal/statusIcon";
import usePlans from "../../hooks/usePlans";
import ColorBoxModal from "../ColorBoxModal";
// import { ColorBox } from "material-ui-color";


const useStyles = makeStyles((theme) => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  return {
    btnWrapper: {
      position: "relative",
    },
    buttonProgress: {
      color: t.brand,
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: -12,
      marginLeft: -12,
    },
    // amostra da cor da fila (cor de dado) dentro do campo
    colorAdorment: {
      width: 18,
      height: 18,
      borderRadius: 4,
      boxShadow: `inset 0 0 0 1px ${t.lineStrong}`,
    },
    afterRows: { marginTop: 14 },
    botTitle: { display: "inline-flex", alignItems: "center", gap: 6 },
  };
});

// corpo da aba de horários no padrão do modal (o rodapé vai no DialogActions)
const SchedulesBody = (props) => {
  const p = usePanelStyles();
  return <DialogContent className={p.modalBody} {...props} />;
};

const QueueSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  color: Yup.string().min(3, "Too Short!").max(9, "Too Long!").required(),
  greetingMessage: Yup.string(),
  chatbots: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string().min(4, "too short").required("Required"),
      })
    )
    .required("Must have friends"),
});

const QueueModal = ({ open, onClose, queueId, onEdit }) => {
  const classes = useStyles();
  const p = usePanelStyles();
  const bt = useBotTreeStyles();

  const initialState = {
    name: "",
    color: "",
    greetingMessage: "",
    chatbots: [],
    outOfHoursMessage: "",
    orderQueue: "",
    tipoIntegracao: "NA",
    tempoRoteador: 0,
    ativarRoteador: false,
    integrationId: "",
    fileListId: "",
    closeTicket: false,
    typeRandomMode: "RANDOM",
    randomizeImmediate: false,
    slaFirstResponseMinutes: "",
    slaResolutionMinutes: "",
    slaWarningPercent: 80,
  };

  const [colorPickerModalOpen, setColorPickerModalOpen] = useState(false);
  const [queue, setQueue] = useState(initialState);
  const greetingRef = useRef();
  const [activeStep, setActiveStep] = useState(null);
  const [selectedQueue, setSelectedQueue] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [isStepContent, setIsStepContent] = useState(true);
  const [isNameEdit, setIsNamedEdit] = useState(null);
  const [isGreetingMessageEdit, setGreetingMessageEdit] = useState(null);
  const [queues, setQueues] = useState([]);

  const [integrations, setIntegrations] = useState([]);
  const [schedulesEnabled, setSchedulesEnabled] = useState(false);
  const [tab, setTab] = useState(0);
  const [file, setFile] = useState(null);
  const { user, socket } = useContext(AuthContext);
  const [searchParam, setSearchParam] = useState("");
  const [loading, setLoading] = useState(false);

  const [selectedQueueOption, setSelectedQueueOption] = useState("");
  const { findAll: findAllQueues } = useQueues();
  const [allQueues, setAllQueues] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const isMounted = useRef(true);

  const initialStateSchedule = [
    { weekday: i18n.t("queueModal.serviceHours.monday"), weekdayEn: "monday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00" },
    { weekday: i18n.t("queueModal.serviceHours.tuesday"), weekdayEn: "tuesday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00" },
    { weekday: i18n.t("queueModal.serviceHours.wednesday"), weekdayEn: "wednesday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00" },
    { weekday: i18n.t("queueModal.serviceHours.thursday"), weekdayEn: "thursday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00" },
    { weekday: i18n.t("queueModal.serviceHours.friday"), weekdayEn: "friday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00" },
    { weekday: "Sábado", weekdayEn: "saturday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00" },
    { weekday: "Domingo", weekdayEn: "sunday", startTimeA: "08:00", endTimeA: "12:00", startTimeB: "13:00", endTimeB: "18:00" }
  ];


  const [schedules, setSchedules] = useState(initialStateSchedule);

  const companyId = user.companyId;

  const { get: getSetting } = useCompanySettings();
  const [showOpenAi, setShowOpenAi] = useState(false);
  const [showIntegrations, setShowIntegrations] = useState(false);
  const { getPlanCompany } = usePlans();

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);

      setShowOpenAi(planConfigs.plan.useOpenAi);
      setShowIntegrations(planConfigs.plan.useIntegrations);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchData = async () => {

      const setting = await getSetting({
        "column": "scheduleType"
      });
      if (setting.scheduleType === "queue") setSchedulesEnabled(true);
    }
    fetchData();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/files/", {
          params: { companyId }
        });

        setFile(data.files);
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (!queueId) return;
      try {
        const { data } = await api.get(`/queue/${queueId}`);

        setQueue((prevState) => {
          return {
            ...prevState,
            ...data,
            slaFirstResponseMinutes: data.slaFirstResponseMinutes ?? "",
            slaResolutionMinutes: data.slaResolutionMinutes ?? "",
            slaWarningPercent: data.slaWarningPercent ?? 80,
          };
        });

        if (isArray(data.schedules) && data.schedules.length > 0)
          setSchedules(data.schedules);
      } catch (err) {
        toastError(err);
      }
    })();

    return () => {
      setQueue({
        name: "",
        color: "",
        greetingMessage: "",
        chatbots: [],
        outOfHoursMessage: "",
        orderQueue: "",
        tipoIntegracao: "NA",
        tempoRoteador: "",
        ativarRoteador: false,
        integrationId: "",
        fileListId: "",
        closeTicket: false,
        typeRandomMode: "RANDOM",
        randomizeImmediate: false,
        slaFirstResponseMinutes: "",
        slaResolutionMinutes: "",
        slaWarningPercent: 80,
      });
    };
  }, [queueId, open]);

  useEffect(() => {
    if (isMounted.current) {
      const loadQueues = async () => {
        const list = await findAllQueues();
        setAllQueues(list);
        setQueues(list);

      };
      loadQueues();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (searchParam.length < 3) {
      setLoading(false);
      setSelectedQueueOption("");
      return;
    }
    const delayDebounceFn = setTimeout(() => {
      //setLoading(true);
      const fetchUsers = async () => {
        try {
          const { data } = await api.get("/users/");
          setUserOptions(data.users);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };

      fetchUsers();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/queueIntegration");

        setIntegrations(data.queueIntegrations);
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  useEffect(() => {

    if (activeStep) {
      setSelectedQueueOption(queue.chatbots[activeStep]?.optQueueId)
    }

    if (activeStep === isNameEdit) {
      setIsStepContent(false);
    } else {
      setIsStepContent(true);
    }
  }, [isNameEdit, activeStep]);

  const handleClose = () => {
    onClose();
    setIsNamedEdit(null);
    setActiveStep(null);
    setGreetingMessageEdit(null);
  };

  const handleSaveSchedules = async (values) => {
    toast.success("Clique em salvar para registar as alterações");
    setSchedules(values);
    setTab(0);
  };

  const filterOptions = createFilterOptions({
    trim: true,
  });

  const handleCloseConfirmationModal = () => {
    setConfirmModalOpen(false);
    setSelectedQueue(null);
  };

  const handleDeleteQueue = async (optionsId) => {
    try {
      await api.delete(`/chatbot/${optionsId}`);
      const { data } = await api.get(`/queue/${queueId}`);
      setQueue(initialState);
      setQueue(data);

      setIsNamedEdit(null);
      setGreetingMessageEdit(null);
      toast.success(`${i18n.t("queues.toasts.deleted")}`);
    } catch (err) {
      toastError(err);
    }
  };

  const normalizeSla = (values) => {
    const toIntOrNull = (v) => {
      if (v === "" || v === null || v === undefined) return null;
      const n = parseInt(v, 10);
      return Number.isFinite(n) && n > 0 ? n : null;
    };
    const warn = parseInt(values.slaWarningPercent, 10);
    return {
      ...values,
      slaFirstResponseMinutes: toIntOrNull(values.slaFirstResponseMinutes),
      slaResolutionMinutes: toIntOrNull(values.slaResolutionMinutes),
      slaWarningPercent: Number.isFinite(warn) ? Math.min(100, Math.max(1, warn)) : 80,
    };
  };

  const handleSaveQueue = async (rawValues) => {
    const values = normalizeSla(rawValues);
    try {
      // Persist tipoIntegracao inside selected integration jsonContent if applicable
      if (values.integrationId && values.tipoIntegracao) {
        try {
          const { data: integrationData } = await api.get(`/queueIntegration/${values.integrationId}`);
          let baseJson = {};
          try {
            baseJson = integrationData?.jsonContent ? JSON.parse(integrationData.jsonContent) : {};
          } catch {}
          const jsonContent = {
            ...baseJson,
            tipoIntegracao: values.tipoIntegracao,
          };
          await api.put(`/queueIntegration/${values.integrationId}`, { jsonContent: JSON.stringify(jsonContent), projectName: integrationData.name });
        } catch (e) {
          // silent fail: queue save continues, but tipoIntegracao may not be persisted
        }
      }
      if (queueId) {
        await api.put(`/queue/${queueId}`, { ...values, schedules });
      } else {
        await api.post("/queue", { ...values, schedules });
      }

      toast.success(`${i18n.t("queues.toasts.success")}`);
      handleClose();
    } catch (err) {
      toastError(err);
    }
  };

  const handleSaveBot = async (rawValues) => {
    const values = normalizeSla(rawValues);
    try {
      if (queueId) {
        const { data } = await api.put(`/queue/${queueId}`, values);
        if (data.chatbots && data.chatbots.length) {
          onEdit(data);
          setQueue(data);
        }
      } else {
        const { data } = await api.post("/queue", values);
        if (data.chatbots && data.chatbots.length) {
          setQueue(data);
          onEdit(data);
          handleClose();
        }
      }

      setIsNamedEdit(null)
      setGreetingMessageEdit(null)
      toast.success(`${i18n.t("queues.toasts.success")}`);

    } catch (err) {
      toastError(err);
    }
  };

  // const renderColorBox = (open, handleClose, color, handleColorChange) => {
  //   return (
  //     <Dialog open={open} onClose={handleClose}>

  //       <DialogTitle>Escolha uma cor</DialogTitle>
  //       <DialogContent>
  //         <ColorBox
  //           disableAlpha={true}
  //           hslGradient={false}
  //           style={{ margin: '20px auto 0' }}
  //           value={color}
  //           onChange={handleColorChange} />
  //       </DialogContent>
  //       <DialogActions>
  //         <Button onClick={handleClose} color="primary">
  //           Cancelar
  //         </Button>
  //         <Button
  //           color="primary"
  //           variant="contained"
  //           className={classes.btnWrapper}
  //           onClick={handleClose} >
  //           OK
  //         </Button>
  //       </DialogActions>
  //     </Dialog>
  //   )
  // }
  return (
    <div>
      <ConfirmationModal
        title={
          selectedQueue &&
          `${i18n.t("queues.confirmationModal.deleteTitle")} ${selectedQueue.name
          }?`
        }
        open={confirmModalOpen}
        onClose={handleCloseConfirmationModal}
        onConfirm={() => handleDeleteQueue(selectedQueue.id)}
      >
        {i18n.t("queueModal.title.confirmationDelete")}
      </ConfirmationModal>
      <Dialog
        maxWidth="md"
        fullWidth
        open={open}
        onClose={handleClose}
        scroll="paper"
        classes={{ paper: p.dialogPaper }}
      >
        <ModalTitle
          title={queueId
            ? `${i18n.t("queueModal.title.edit")}`
            : `${i18n.t("queueModal.title.add")}`}
          subtitle="Setor de atendimento, rodízio, mensagens e opções do chatbot."
          onClose={handleClose}
        />
        {/* com uma aba só (horário por fila desligado) a barra de abas é ruído */}
        {schedulesEnabled && (
          <Tabs
            value={tab}
            indicatorColor="primary"
            textColor="primary"
            onChange={(e, v) => setTab(v)}
            aria-label={i18n.t("queueModal.title.edit")}
            className={p.modalTabs}
          >
            <Tab label={i18n.t("queueModal.title.queueData")} />
            {schedulesEnabled && <Tab label={i18n.t("queueModal.title.text")} />}
          </Tabs>
        )}
        {tab === 0 && (
          <Formik
            initialValues={queue}
            validateOnChange={false}
            enableReinitialize={true}
            validationSchema={QueueSchema}
            onSubmit={(values, actions) => {
              setTimeout(() => {
                handleSaveQueue(values);
                actions.setSubmitting(false);
              }, 400);
            }}
          >
            {({ setFieldValue, touched, errors, isSubmitting, values }) => (
              <Form className={p.modalForm}>
                <DialogContent className={clsx(p.modalBody, p.labelsAbove)}>
                  <FormSection title="Identificação">
                    <div className={p.grid3}>
                      <Field
                        as={TextField}
                        label={i18n.t("queueModal.form.name")}
                        autoFocus
                        name="name"
                        error={touched.name && Boolean(errors.name)}
                        helperText={touched.name && errors.name}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                      />
                      <Field
                        as={TextField}
                        label={i18n.t("queueModal.form.color")}
                        name="color"
                        id="color"
                        onFocus={() => {
                          setColorPickerModalOpen(true);
                          greetingRef.current.focus();
                        }}
                        error={touched.color && Boolean(errors.color)}
                        helperText={touched.color && errors.color}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <div
                                style={{ backgroundColor: values.color }}
                                className={classes.colorAdorment}
                              ></div>
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                size="small"
                                color="default"
                                edge="end"
                                aria-label="Escolher cor"
                                onClick={() => setColorPickerModalOpen(!colorPickerModalOpen)}
                              >
                                <Colorize fontSize="small" />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                      />
                      <Field
                        as={TextField}
                        label={i18n.t("queueModal.form.orderQueue")}
                        name="orderQueue"
                        type="orderQueue"
                        error={touched.orderQueue && Boolean(errors.orderQueue)}
                        helperText={touched.orderQueue && errors.orderQueue}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                      />
                    </div>
                    <ColorBoxModal
                      open={colorPickerModalOpen}
                      handleClose={() => setColorPickerModalOpen(false)}
                      onChange={(color) => {
                        setFieldValue("color", `#${color.hex}`);
                      }}
                      currentColor={values.color}
                    />
                  </FormSection>

                  <FormSection title="Atendimento e rodízio">
                    <SettingRow label={i18n.t("queueModal.form.closeTicket")}>
                      <Field
                        as={Switch}
                        color="primary"
                        name="closeTicket"
                        checked={values.closeTicket}
                        inputProps={{ "aria-label": i18n.t("queueModal.form.closeTicket") }}
                      />
                    </SettingRow>
                    <SettingRow label={i18n.t("queueModal.form.rotate")}>
                      <Field
                        as={Switch}
                        color="primary"
                        name="ativarRoteador"
                        checked={values.ativarRoteador}
                        inputProps={{ "aria-label": i18n.t("queueModal.form.rotate") }}
                      />
                    </SettingRow>
                    <div className={clsx(p.grid2, classes.afterRows)}>
                      <FormControl variant="outlined" margin="dense" fullWidth disabled={!values.ativarRoteador}>
                        <InputLabel id="tempoRoteador-label">
                          {i18n.t("queueModal.form.timeRotate")}
                        </InputLabel>
                        <Field
                          as={Select}
                          label={i18n.t("queueModal.form.timeRotate")}
                          labelId="tempoRoteador-label"
                          name="tempoRoteador"
                          id="tempoRoteador"
                          variant="outlined"
                          margin="dense"
                          disabled={!values.ativarRoteador}
                        >
                          <MenuItem value="0" selected disabled>{i18n.t("queueModal.form.timeRotate")}</MenuItem>
                          <MenuItem value="1">1 minuto</MenuItem>
                          <MenuItem value="2">2 minutos</MenuItem>
                          <MenuItem value="3">3 minutos</MenuItem>
                          <MenuItem value="4">4 minutos</MenuItem>
                          <MenuItem value="5">5 minutos</MenuItem>
                          <MenuItem value="10">10 minutos</MenuItem>
                          <MenuItem value="15">15 minutos</MenuItem>
                          <MenuItem value="30">30 minutos</MenuItem>
                          <MenuItem value="45">45 minutos</MenuItem>
                          <MenuItem value="60">60 minutos</MenuItem>
                        </Field>
                      </FormControl>
                      <FormControl variant="outlined" margin="dense" fullWidth disabled={!values.ativarRoteador}>
                        <InputLabel id="typeRandomMode-label">
                          {i18n.t("queueModal.form.typeRandomMode")}
                        </InputLabel>
                        <Field
                          as={Select}
                          label={i18n.t("queueModal.form.typeRandomMode")}
                          labelId="typeRandomMode-label"
                          name="typeRandomMode"
                          id="typeRandomMode"
                          variant="outlined"
                          margin="dense"
                          disabled={!values.ativarRoteador}
                        >
                          <MenuItem value="0" selected disabled>{i18n.t("Selecione o tipo de rodízio")}</MenuItem>
                          <MenuItem value="RANDOM">Random</MenuItem>
                          <MenuItem value="ORDENADO">Ordenado</MenuItem>
                        </Field>
                      </FormControl>
                      <FormControlLabel
                        className={clsx(p.span2, bt.check)}
                        control={
                          <Field
                            as={Checkbox}
                            color="primary"
                            name="randomizeImmediate"
                            checked={values.randomizeImmediate}
                            disabled={!values.ativarRoteador}
                          />
                        }
                        label={
                          <span>
                            {i18n.t("queueModal.form.randomizeImmediate")}
                          </span>
                        }
                      />
                    </div>
                  </FormSection>

                  <FormSection title="Integração e arquivos">
                    <div className={p.grid2}>
                      {showIntegrations && (
                        <FormControl
                          variant="outlined"
                          margin="dense"
                          fullWidth
                        >
                          <InputLabel id="integrationId-selection-label">
                            {i18n.t("queueModal.form.integrationId")}
                          </InputLabel>
                          <Field
                            as={Select}
                            label={i18n.t("queueModal.form.integrationId")}
                            name="integrationId"
                            id="integrationId"
                            placeholder={i18n.t("queueModal.form.integrationId")}
                            labelId="integrationId-selection-label"
                            value={values.integrationId || ""}
                            displayEmpty
                          >
                            <MenuItem value={""} >{"Nenhum"}</MenuItem>
                            {integrations.map((integration) => (
                              <MenuItem key={integration.id} value={integration.id}>
                                {integration.name}
                              </MenuItem>
                            ))}
                          </Field>

                        </FormControl>
                      )}
                      {values.integrationId !== "" && (
                        <FormControl variant="outlined" margin="dense" fullWidth>
                          <InputLabel id="tpIntegrationId-selection-label">
                            {i18n.t("queueModal.form.tipoIntegracao")}
                          </InputLabel>
                          <Field
                            as={Select}
                            label={i18n.t("queueModal.form.tipoIntegracao")}
                            labelId="tpIntegrationId-selection-label"
                            name="tipoIntegracao"
                            id="tipoIntegracao"
                            variant="outlined"
                            margin="dense"
                          >
                            <MenuItem value="NA" selected disabled>{i18n.t("erp.integrationTypes.NA")}</MenuItem>
                            <MenuItem value="SB">{i18n.t("erp.integrationTypes.SB")}</MenuItem>
                            <MenuItem value="AV">{i18n.t("erp.integrationTypes.AV")}</MenuItem>
                            <MenuItem value="VE">{i18n.t("erp.integrationTypes.VE")}</MenuItem>
                            <MenuItem value="LC">{i18n.t("erp.integrationTypes.LC")}</MenuItem>
                            <MenuItem value="ST">{i18n.t("erp.integrationTypes.ST")}</MenuItem>
                          </Field>
                        </FormControl>
                      )}
                      <FormControl
                        variant="outlined"
                        margin="dense"
                        fullWidth
                      >
                        <InputLabel id="fileListId-selection-label">{i18n.t("queueModal.form.fileListId")}</InputLabel>
                        <Field
                          as={Select}
                          label={i18n.t("queueModal.form.fileListId")}
                          name="fileListId"
                          id="fileListId"
                          placeholder={i18n.t("queueModal.form.fileListId")}
                          labelId="fileListId-selection-label"
                          value={values.fileListId || ""}
                          displayEmpty
                        >
                          <MenuItem value={""} >{"Nenhum"}</MenuItem>
                          {(file || []).map(f => (
                            <MenuItem key={f.id} value={f.id}>
                              {f.name}
                            </MenuItem>
                          ))}
                        </Field>
                      </FormControl>
                    </div>
                  </FormSection>

                  <FormSection
                    title={i18n.t("queueModal.form.slaTitle")}
                    description={i18n.t("queueModal.form.slaHint")}
                  >
                    <div className={p.grid3}>
                      <Field
                        as={TextField}
                        label={i18n.t("queueModal.form.slaFirstResponse")}
                        name="slaFirstResponseMinutes"
                        type="number"
                        inputProps={{ min: 1, step: 1 }}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                      />
                      <Field
                        as={TextField}
                        label={i18n.t("queueModal.form.slaResolution")}
                        name="slaResolutionMinutes"
                        type="number"
                        inputProps={{ min: 1, step: 1 }}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                      />
                      <Field
                        as={TextField}
                        label={i18n.t("queueModal.form.slaWarning")}
                        name="slaWarningPercent"
                        type="number"
                        inputProps={{ min: 1, max: 100, step: 1 }}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                      />
                    </div>
                  </FormSection>

                  <FormSection title="Mensagens">
                    <div className={p.stack}>
                      <Field
                        as={TextField}
                        label={i18n.t("queueModal.form.greetingMessage")}
                        type="greetingMessage"
                        multiline
                        inputRef={greetingRef}
                        minRows={5}
                        fullWidth
                        name="greetingMessage"
                        error={
                          touched.greetingMessage && Boolean(errors.greetingMessage)
                        }
                        helperText={
                          touched.greetingMessage && errors.greetingMessage
                        }
                        variant="outlined"
                        margin="dense"
                      />
                      {schedulesEnabled && (
                        <Field
                          as={TextField}
                          label={i18n.t("queueModal.form.outOfHoursMessage")}
                          type="outOfHoursMessage"
                          multiline
                          rows={5}
                          fullWidth
                          required={schedulesEnabled}
                          name="outOfHoursMessage"
                          error={
                            touched.outOfHoursMessage &&
                            Boolean(errors.outOfHoursMessage)
                          }
                          helperText={
                            touched.outOfHoursMessage && errors.outOfHoursMessage
                          }
                          variant="outlined"
                          margin="dense"
                        />
                      )}
                    </div>
                  </FormSection>

                  <FormSection
                    title={
                      <span className={classes.botTitle}>
                        {i18n.t("queueModal.bot.title")}
                        <CustomToolTip
                          title={i18n.t("queueModal.bot.toolTipTitle")}
                          content={i18n.t("queueModal.bot.toolTip")}
                        >
                          <HelpOutlineOutlinedIcon className={bt.helpIcon} />
                        </CustomToolTip>
                      </span>
                    }
                  >
                    <FieldArray name="chatbots">
                      {({ push, remove }) => (
                        <BotTree>
                          {values.chatbots &&
                            values.chatbots.length > 0 &&
                            values.chatbots.map((info, index) => (
                              <BotNode
                                key={`${info.id ? info.id : index}-chatbots`}
                                number={index + 1}
                                active={activeStep === index}
                                onActivate={() => setActiveStep(index)}
                                header={
                                  isNameEdit !== index &&
                                    queue.chatbots[index]?.name ? (
                                    <BotTitle
                                      active={activeStep === index}
                                      actions={
                                        <>
                                          <BotIconButton
                                            title="Editar opção"
                                            onClick={() => {
                                              setIsNamedEdit(index);
                                              setIsStepContent(false);
                                            }}
                                          >
                                            <EditIcon />
                                          </BotIconButton>
                                          <BotIconButton
                                            title="Excluir opção"
                                            danger
                                            onClick={() => {
                                              setSelectedQueue(info);
                                              setConfirmModalOpen(true);
                                            }}
                                          >
                                            <DeleteOutline />
                                          </BotIconButton>
                                        </>
                                      }
                                    >
                                      {values.chatbots[index].name}
                                    </BotTitle>
                                  ) : (
                                    <div className={bt.panel}>
                                      <Field
                                        as={TextField}
                                        name={`chatbots[${index}].name`}
                                        variant="outlined"
                                        margin="dense"
                                        color="primary"
                                        label={i18n.t("queueModal.form.greetingMessage")}
                                        disabled={isSubmitting}
                                        autoFocus
                                        fullWidth
                                        size="small"
                                        error={
                                          touched?.chatbots?.[index]?.name &&
                                          Boolean(
                                            errors.chatbots?.[index]?.name
                                          )
                                        }
                                      />
                                      <FormControl
                                        variant="outlined"
                                        margin="dense"
                                        fullWidth
                                      >
                                        <InputLabel id={`queueType-selection-label-${index}`}>{i18n.t("queueModal.form.queueType")}</InputLabel>

                                        <Field
                                          as={Select}
                                          name={`chatbots[${index}].queueType`}
                                          variant="outlined"
                                          margin="dense"
                                          fullWidth
                                          labelId={`queueType-selection-label-${index}`}
                                          label={i18n.t("queueModal.form.queueType")}
                                          error={touched?.chatbots?.[index]?.queueType &&
                                            Boolean(errors?.chatbots?.[index]?.queueType)}
                                        // helpertext={touched?.chatbots?.[index]?.queueType && errors?.chatbots?.[index]?.queueType}
                                        // value={`chatbots[${index}].queueType`}
                                        >
                                          <MenuItem value={"text"}>{i18n.t("queueModal.bot.text")}</MenuItem>
                                          <MenuItem value={"attendent"}>{i18n.t("queueModal.bot.attendent")}</MenuItem>
                                          <MenuItem value={"queue"}>{i18n.t("queueModal.bot.queue")}</MenuItem>
                                          <MenuItem value={"integration"}>{i18n.t("queueModal.bot.integration")}</MenuItem>
                                          <MenuItem value={"file"}>{i18n.t("queueModal.bot.file")}</MenuItem>
                                        </Field>
                                      </FormControl>
                                      <div className={bt.panelRow}>
                                        <FormControlLabel
                                          className={bt.check}
                                          control={
                                            <Field
                                              as={Checkbox}
                                              color="primary"
                                              name={`chatbots[${index}].closeTicket`}
                                              checked={values.chatbots[index].closeTicket || false}
                                            />
                                          }
                                          label={i18n.t("queueModal.form.closeTicket")}
                                        />
                                        <span className={bt.panelGrow} />
                                        <div className={bt.actions}>
                                          <BotIconButton
                                            title="Salvar opção"
                                            onClick={() =>
                                              values.chatbots[index].name
                                                ? handleSaveBot(values)
                                                : null
                                            }
                                            disabled={isSubmitting}
                                          >
                                            <SaveIcon />
                                          </BotIconButton>
                                          <BotIconButton
                                            title="Remover opção"
                                            danger
                                            onClick={() => remove(index)}
                                            disabled={isSubmitting}
                                          >
                                            <DeleteOutline />
                                          </BotIconButton>
                                        </div>
                                      </div>
                                    </div>
                                  )
                                }
                              >
                                {isStepContent && queue.chatbots[index] && (
                                  <>
                                    {isGreetingMessageEdit !== index ? (
                                      <div className={bt.message}>
                                        <div className={bt.messageBody}>
                                          <div className={bt.messageLabel}>
                                            {i18n.t("queueModal.form.message")}
                                            {!queue.chatbots[index]
                                              ?.greetingMessage && (
                                                <CustomToolTip
                                                  title={i18n.t("queueModal.bot.toolTipMessageTitle")}
                                                  content={i18n.t("queueModal.bot.toolTipMessageContent")}
                                                >
                                                  <HelpOutlineOutlinedIcon className={bt.helpIcon} />
                                                </CustomToolTip>
                                              )}
                                          </div>
                                          <div
                                            className={clsx(
                                              bt.messageText,
                                              !values.chatbots[index].greetingMessage && bt.messageEmpty
                                            )}
                                          >
                                            {values.chatbots[index].greetingMessage || "—"}
                                          </div>
                                        </div>
                                        <BotIconButton
                                          title="Editar mensagem"
                                          onClick={() =>
                                            setGreetingMessageEdit(index)
                                          }
                                        >
                                          <EditIcon />
                                        </BotIconButton>
                                      </div>
                                    ) : (
                                      <div className={bt.panel}>
                                        {["text", "queue", "attendent", "integration", "file"].includes(
                                          queue.chatbots[index].queueType
                                        ) && (
                                            <Field
                                              as={TextField}
                                              name={`chatbots[${index}].greetingMessage`}
                                              label={i18n.t("queueModal.form.message")}
                                              variant="outlined"
                                              margin="dense"
                                              fullWidth
                                              multiline
                                              error={
                                                touched.greetingMessage &&
                                                Boolean(errors.greetingMessage)
                                              }
                                              helperText={
                                                touched.greetingMessage &&
                                                errors.greetingMessage
                                              }
                                            />
                                          )}
                                        {queue.chatbots[index].queueType === "queue" && (
                                          <FormControl
                                            variant="outlined"
                                            margin="dense"
                                            fullWidth
                                          >
                                            <InputLabel id={`queue-selection-label-${index}`}>{i18n.t("queueModal.form.queue")}</InputLabel>
                                            <Field
                                              as={Select}
                                              name={`chatbots[${index}].optQueueId`}
                                              labelId={`queue-selection-label-${index}`}
                                              label={i18n.t("queueModal.form.queue")}
                                              error={touched?.chatbots?.[index]?.optQueueId &&
                                                Boolean(errors?.chatbots?.[index]?.optQueueId)}
                                              helpertext={touched?.chatbots?.[index]?.optQueueId && errors?.chatbots?.[index]?.optQueueId}
                                            // value={`chatbots[${index}].optQueueId`}
                                            >
                                              {queues.map(queue => (
                                                <MenuItem key={queue.id} value={queue.id}>
                                                  {queue.name}
                                                </MenuItem>
                                              ))}
                                            </Field>
                                          </FormControl>
                                        )}
                                        {queue.chatbots[index].queueType === "attendent" && (
                                          <div className={p.grid2}>
                                            {/* SELECIONAR USUARIO */}
                                            <Autocomplete
                                              getOptionLabel={(option) => `${option.name}`}
                                              value={queue.chatbots[index].user}
                                              onChange={(e, newValue) => {
                                                if (newValue != null) {
                                                  setFieldValue(`chatbots[${index}].optUserId`, newValue.id);
                                                } else {
                                                  setFieldValue(`chatbots[${index}].optUserId`, null);

                                                }
                                                if (newValue != null && Array.isArray(newValue.queues)) {
                                                  if (newValue.queues.length === 1) {
                                                    setSelectedQueueOption(newValue.queues[0].id);
                                                    setFieldValue(`chatbots[${index}].optQueueId`, newValue.queues[0].id);
                                                  }
                                                  setQueues(newValue.queues);

                                                } else {
                                                  setQueues(allQueues);
                                                  setSelectedQueueOption("");
                                                }
                                              }}
                                              options={userOptions}
                                              filterOptions={filterOptions}
                                              freeSolo
                                              fullWidth
                                              autoHighlight
                                              noOptionsText={i18n.t("transferTicketModal.noOptions")}
                                              loading={loading}
                                              size="small"
                                              renderOption={option => (<span> <UserStatusIcon user={option} /> {option.name}</span>)}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  label={i18n.t("transferTicketModal.fieldLabel")}
                                                  variant="outlined"
                                                  onChange={(e) => setSearchParam(e.target.value)}
                                                  InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                      <Fragment>
                                                        {loading ? (
                                                          <CircularProgress color="inherit" size={20} />
                                                        ) : null}
                                                        {params.InputProps.endAdornment}
                                                      </Fragment>
                                                    ),
                                                  }}
                                                />
                                              )}
                                            />
                                            <FormControl
                                              variant="outlined"
                                              margin="dense"
                                              fullWidth
                                            >
                                              <InputLabel id={`attendent-queue-label-${index}`}>
                                                {i18n.t("transferTicketModal.fieldQueueLabel")}
                                              </InputLabel>
                                              <Select
                                                value={selectedQueueOption}
                                                onChange={(e) => {
                                                  setSelectedQueueOption(e.target.value)
                                                  setFieldValue(`chatbots[${index}].optQueueId`, e.target.value);
                                                }}
                                                labelId={`attendent-queue-label-${index}`}
                                                label={i18n.t("transferTicketModal.fieldQueuePlaceholder")}
                                              >
                                                {queues.map((queue) => (
                                                  <MenuItem key={queue.id} value={queue.id}>
                                                    {queue.name}
                                                  </MenuItem>
                                                ))}
                                              </Select>
                                            </FormControl>
                                          </div>
                                        )}
                                        {queue.chatbots[index].queueType === "integration" && (
                                          <FormControl
                                            variant="outlined"
                                            margin="dense"
                                            fullWidth
                                          >
                                            <InputLabel id={`optIntegrationId-selection-label-${index}`}>{i18n.t("queueModal.form.integration")}</InputLabel>
                                            <Field
                                              as={Select}
                                              name={`chatbots[${index}].optIntegrationId`}
                                              labelId={`optIntegrationId-selection-label-${index}`}
                                              label={i18n.t("queueModal.form.integration")}
                                              error={touched?.chatbots?.[index]?.optIntegrationId &&
                                                Boolean(errors?.chatbots?.[index]?.optIntegrationId)}
                                              helpertext={touched?.chatbots?.[index]?.optIntegrationId && errors?.chatbots?.[index]?.optIntegrationId}
                                            // value={`chatbots[${index}].optQueueId`}
                                            >
                                              {integrations.map(integration => (
                                                <MenuItem key={integration.id} value={integration.id}>
                                                  {integration.name}
                                                </MenuItem>
                                              ))}
                                            </Field>
                                          </FormControl>
                                        )}
                                        {queue.chatbots[index].queueType === "file" && (
                                          <FormControl
                                            variant="outlined"
                                            margin="dense"
                                            fullWidth
                                          >
                                            <InputLabel id={`optFileId-selection-label-${index}`}>{"Selecione um Arquivo"}</InputLabel>
                                            <Field
                                              as={Select}
                                              name={`chatbots[${index}].optFileId`}
                                              labelId={`optFileId-selection-label-${index}`}
                                              label={"Selecione um Arquivo"}
                                              error={touched?.chatbots?.[index]?.optFileId &&
                                                Boolean(errors?.chatbots?.[index]?.optFileId)}
                                              helpertext={touched?.chatbots?.[index]?.optFileId && errors?.chatbots?.[index]?.optFileId}
                                            >
                                              {(file || []).map(f => (
                                                <MenuItem key={f.id} value={f.id}>
                                                  {f.name}
                                                </MenuItem>
                                              ))}
                                            </Field>
                                          </FormControl>
                                        )}
                                        <div className={bt.panelRow}>
                                          <span className={bt.panelGrow} />
                                          <BotIconButton
                                            title="Salvar opção"
                                            onClick={() =>
                                              handleSaveBot(values)
                                            }
                                            disabled={isSubmitting}
                                          >
                                            <SaveIcon />
                                          </BotIconButton>
                                        </div>
                                      </div>
                                    )}

                                    <OptionsChatBot chatBotId={info.id} />
                                  </>
                                )}
                              </BotNode>
                            ))}

                          <BotAdd
                            label={i18n.t("queueModal.bot.addOptions")}
                            onClick={() => push({ name: "", value: "" })}
                          />
                        </BotTree>
                      )}
                    </FieldArray>
                  </FormSection>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={handleClose}
                    // color="secondary"
                    disabled={isSubmitting}
                  // variant="outlined"
                  >
                    {i18n.t("queueModal.buttons.cancel")}
                  </Button>
                  <Button
                    type="submit"
                    color="primary"
                    disabled={isSubmitting}
                    variant="contained"
                    className={classes.btnWrapper}
                  >
                    {queueId
                      ? `${i18n.t("queueModal.buttons.okEdit")}`
                      : `${i18n.t("queueModal.buttons.okAdd")}`}
                    {isSubmitting && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    )}
                  </Button>
                </DialogActions>
              </Form>
            )}
          </Formik>
        )}
        {tab === 1 && (
          <SchedulesForm
            loading={false}
            onSubmit={handleSaveSchedules}
            initialValues={schedules}
            labelSaveButton={i18n.t("whatsappModal.buttons.okAdd")}
            className={p.modalForm}
            BodyComponent={SchedulesBody}
            FooterComponent={DialogActions}
          />
        )}
      </Dialog>
    </div >
  );
};

export default QueueModal;
